/**
 * Tier limits shown in the cockpit. Mirrors intervyo-app services/limits.ts
 * (read 29 Oct 2026). The database (reserve_usage, check_usage) and coach-chat
 * are the enforcement truth; these copies are for display only.
 * Prices live in lib/money.ts (LIST_PRICE), per currency.
 */

/** Free-tier lifetime caps (free_usage columns). */
export const FREE_LIMITS = {
  hv: 2,
  psy: 1,
  mocks: 0,
  cv: 1,
  cv_create: 1,
  cover_letter: 3,
  cover_letter_create: 1,
  cover_letter_analyse: 1,
  research: 1,
  technical: 1,
} as const;

/** Vyo message limits enforced in coach-chat (free lifetime; paid resets on the 1st of the UTC month). */
export const VYO_LIMITS = {
  free_lifetime: 8,
  subscription_monthly: 200,
  pack_bonus: 50,
} as const;
